import styles from "./PolicyViewer.module.css";

export default function PolicyViewer({
title,
icon,
content,
onBack
}) {

return (

<div className={styles.wrapper}>

<div className={styles.hero}>

<button
className={styles.back}
onClick={onBack}
>
← Back
</button>

<div className={styles.header}>

<div className={styles.icon}>
{icon}
</div>

<div>

<div className={styles.badge}>
LEGAL DOCUMENT
</div>

<h1>
{title}
</h1>

<div className={styles.date}>
Updated June 17, 2026
</div>

</div>

</div>

</div>

<div className={styles.paper}>

<div className={styles.readingBar}></div>

<div className={styles.document}>

{content
.split("\n")
.map((line,index)=>{

const text=line.trim();

if(!text)
return <div key={index} className={styles.space}></div>;

if(
text.length<70 &&
!text.includes(":") &&
text===text.toUpperCase()
){

return(
<h2
key={index}
className={styles.section}
>
{text}
</h2>
);

}

if(
text.startsWith("•")
){

return(

<li
key={index}
className={styles.bullet}
>
{text.replace("•","")}
</li>

);

}

return(

<p
key={index}
className={styles.paragraph}
>
{text}
</p>

);

})}

</div>

</div>

</div>

);

}